

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {Tooltip} from '@mui/material';

interface TooltipProps {
    text: string;
}
const ToolTip = ({ text }: TooltipProps) => {
    return (        
        
            <Tooltip title={text} arrow>
                <InfoOutlinedIcon
                    sx={{ ml: 0.5, height:'16px', width:'17px', verticalAlign: 'text-top', color: '#404040' }}
                />
            </Tooltip>   
    );
};

export default ToolTip;
